import React from 'react';
import { SubjectType } from '../../types/Card';

interface CardFiltersProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  selectedSubject: SubjectType | 'all';
  onSubjectChange: (subject: SubjectType | 'all') => void;
  showPinnedOnly: boolean;
  onPinnedOnlyChange: (showPinnedOnly: boolean) => void;
}

const SUBJECT_OPTIONS: { value: SubjectType | 'all'; label: string; emoji: string }[] = [
  { value: 'all', label: 'All Subjects', emoji: '📚' },
  { value: 'science', label: 'Science', emoji: '🔬' },
  { value: 'history', label: 'History', emoji: '🏛️' },
  { value: 'space', label: 'Space', emoji: '🚀' },
  { value: 'geography', label: 'Geography', emoji: '🌍' },
  { value: 'maths', label: 'Mathematics', emoji: '🔢' },
  { value: 'computing', label: 'Computing', emoji: '💻' },
  { value: 'art', label: 'Art', emoji: '🎨' },
];

export const CardFilters: React.FC<CardFiltersProps> = ({
  searchTerm,
  onSearchChange,
  selectedSubject,
  onSubjectChange,
  showPinnedOnly,
  onPinnedOnlyChange,
}) => {
  return (
    <div className="card-filters">
      <div className="filter-row">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by topic name..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="search-input"
            aria-label="Search cards by topic name"
          />
          {searchTerm && (
            <button
              onClick={() => onSearchChange('')}
              className="clear-search"
              aria-label="Clear search"
            >
              ✕
            </button>
          )}
        </div>

        <div className="subject-filter">
          <label htmlFor="subject-select" className="filter-label">
            Subject:
          </label>
          <select
            id="subject-select"
            value={selectedSubject}
            onChange={(e) => onSubjectChange(e.target.value as SubjectType | 'all')}
            className="subject-select"
            aria-label="Filter by subject"
          >
            {SUBJECT_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.emoji} {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="pinned-filter">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={showPinnedOnly}
              onChange={(e) => onPinnedOnlyChange(e.target.checked)}
              className="checkbox-input"
              aria-label="Show pinned cards only"
            />
            <span>Pinned only</span>
          </label>
        </div>
      </div>
    </div>
  );
};
